import {
  DOBOX_TAB_PARAM_VALUE,
  URL_PARAMS,
} from '../../hooks/DataFetch/constants';
import { APP_PAGES } from '../../routes/constants';

export function buildDoBoxMonitorPath(
  monitorId: string,
  taskGroupId: string,
): string {
  const params = new URLSearchParams({
    [URL_PARAMS.TASK_GROUP_ID]: taskGroupId,
    [URL_PARAMS.DOBOX_TAB]: DOBOX_TAB_PARAM_VALUE.WATCHING,
    [URL_PARAMS.MONITOR]: monitorId,
  });
  return `${APP_PAGES.DOBOX}?${params.toString()}`;
}
